import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Search = createSvgIcon(
  () => (
    <path d="M49.8108 43.2195L40.0547 33.4634C39.5669 33.0732 38.9815 32.7805 38.3961 32.7805H36.8352C39.4693 29.3659 41.1278 25.0732 41.1278 20.2927C41.1278 9.17073 31.9571 0 20.8352 0C9.61565 0 0.54248 9.17073 0.54248 20.2927C0.54248 31.5122 9.61565 40.5854 20.8352 40.5854C25.5181 40.5854 29.8108 39.0244 33.323 36.2927V37.9512C33.323 38.5366 33.5181 39.122 34.0059 39.6098L43.6644 49.2683C44.64 50.2439 46.1035 50.2439 46.9815 49.2683L49.7132 46.5366C50.6888 45.6585 50.6888 44.1951 49.8108 43.2195ZM20.8352 32.7805C13.9083 32.7805 8.34736 27.2195 8.34736 20.2927C8.34736 13.4634 13.9083 7.80488 20.8352 7.80488C27.6644 7.80488 33.323 13.4634 33.323 20.2927C33.323 27.2195 27.6644 32.7805 20.8352 32.7805Z" />
  ),
  '0 0 51 50'
);
